<h2 mat-dialog-title>Restore this record</h2>
<mat-dialog-content>Are you sure?</mat-dialog-content>
<mat-dialog-actions align="center">
    <button id="noButton" mat-button mat-dialog-close>No</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-button [mat-dialog-close]="true">Yes</button>
</mat-dialog-actions>